import React from 'react';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import { v4 as uuidV4 } from 'uuid';
import { Divider } from '@material-ui/core';
import { useHistory } from 'react-router';
import { getDate } from 'app/shared/util/date-utils';
import './popup.scss';
import Loader from '../../spb/loader/loader';
import { useSelector} from 'react-redux';
import { getContractEngineSelector } from 'app/modules/cms/service/store/selectors';

export interface SimpleDialogProps {
  open: boolean;
  selectedValue?: string;
  setOpen: (value: boolean) => void;
  data?: any;
  dataClaimCms?: any;
  dataInfoCms?: any;
}

function PopUp(props: SimpleDialogProps) {
  const { setOpen, open, data, dataInfoCms, dataClaimCms } = props;
  const contractEngineCmsData: any = useSelector(getContractEngineSelector);
  const history = useHistory();
  const handleClose = () => {
    setOpen(false);
  };


  return (
    <Dialog className='popupLounge' onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullScreen={false}>
      <div className="d-flex flex-row justify-content-between">
        <CloseIcon className="popup-close-icone" onClick={handleClose} />
      </div>
      <Divider />
      {data?.loading ? (
        <Loader />
      ) : (
        <List>
          {data?.claimsList?.map(el => (
            <React.Fragment key={uuidV4()}>
              <ListItem
                className="popup-item"
                button
                onClick={() => {
                  history.push({
                    pathname: `/claim-engine`,
                    state: { claimNumber: el.claimNumber },
                  });
                }}
                key={uuidV4()}
              >
                <div className={'d-flex flex-column'}>
                  <p className="title-text">{`${dataInfoCms?.claimItem?.claim_number_label || contractEngineCmsData?.contract_recap?.claim_number_label} ${el?.claimNumber}`}</p>
                  <p className="text-gray">{`${dataInfoCms?.claimItem?.claim_declare_date_label || contractEngineCmsData?.contract_recap?.claim_declare_date_label} ${getDate(el.occurenceDate)} `}</p>
                  <p className="text-gray">{`${el?.cover?.label}`}</p>
                  <div className={'border border-secondary rounded text-center px-2'}>{el?.claimStatus?.label}</div>
                </div>
              </ListItem>
              <br />
            </React.Fragment>
          ))}
        </List>
      )}
    </Dialog>
  );
}
export default PopUp;
